import {
  FETCH_LIST,
  LIST_FETCHED,
  SHOW_INFO_DIALOG,
  HIDE_INFO_DIALOG,
  UPDATED,
  TOGGLE_LOADING,
  READ_USER_NOTIFY,
  SHOW_SEND_NOTIFY_DIALOG,
  DELETE_NOTIFY,
  SEND_NOTIFY_HISTORY_DIALOG,
  FETCH_USER_NOTIFY_LIST,
  DELETE_USER_NOTIFY,
  READ_USER_ALL_NOTIFY,
  NOTIFY_FETCHED,
  FETCH_NOTIFY_CENTER_MESSAGE,
  NO_DO_FEEDBACK_NUM,
  FETCH_NO_DO_FEEDBACK_NUM
} from './actionTypes'

export const fetchList = (params) => ({
  type: FETCH_LIST,
  payload: {
    params
  }
})

export const fetchUserNotifyList = (params) => ({
  type: FETCH_USER_NOTIFY_LIST,
  payload: {
    params
  }
})


export const listFetched = result => ({
  type: LIST_FETCHED,
  payload: result
})

export const showInfoDialog = params => ({
  type: SHOW_INFO_DIALOG,
  payload: { params }
})

export const hideInfoDialog = () => ({
  type: HIDE_INFO_DIALOG
})

export const toggleLoading = () => ({
  type: TOGGLE_LOADING
})

export const updated = (id, data) => ({
  type: UPDATED,
  payload: { id, data }
})

export const readUserNotify = (id, callback) => ({
  type: READ_USER_NOTIFY,
  payload: { id, callback }
})

export const readUserAllNotify = (callback) => ({
  type: READ_USER_ALL_NOTIFY,
  payload: { callback }
})

export const showSendNotifyDialog = params => ({
  type: SHOW_SEND_NOTIFY_DIALOG,
  payload: { params }
})

export const showSendHistoryDialog = params => ({
  type: SEND_NOTIFY_HISTORY_DIALOG,
  payload: { params }
})

export const deleteNotify = (id, callback) => ({
  type: DELETE_NOTIFY,
  payload: { id, callback }
})

export const deleteUserNotify = (id, callback) => ({
  type: DELETE_USER_NOTIFY,
  payload: { id, callback }
})

export const getUserUnReadNotifyCount = (callback) => ({
  type: GET_USER_UNREAD_NOTIFY_COUNT,
  payload: { callback }
})
export const notifyFetched = payload => ({ type: NOTIFY_FETCHED, payload })
export const fetchedNotify = payload => ({ type: FETCH_NOTIFY_CENTER_MESSAGE, payload })
export const noDoFeedback = payload => ({ type: NO_DO_FEEDBACK_NUM, payload })
export const fetchNoDoFeedback = payload => ({ type: FETCH_NO_DO_FEEDBACK_NUM, payload })
